export { default as SyncScroll } from './SyncScroll';
